import React from 'react';
import './Legal.css';

const TerminosUso = () => {
  return (
    <div className="legal-container">
      <div className="legal-content">
        <h1>Términos y Condiciones de Uso</h1>
        <p className="legal-fecha">Última actualización: 12 de octubre de 2026</p>
        <p><a href="/terms-of-service">Read these terms in English</a></p>

        <section>
          <h2>1. Aceptación de los términos</h2>
          <p>
            Al acceder y utilizar la plataforma <strong>Xaltech Fotos</strong> (sitio web y bot de WhatsApp),
            usted acepta quedar vinculado por estos Términos y Condiciones de Uso. Si no está de acuerdo con
            alguno de estos términos, le pedimos no utilizar el servicio. La plataforma es operada por
            <strong> Xaltech Manufacturing Services SA de CV</strong>.
          </p>
        </section>

        <section>
          <h2>2. Descripción del servicio</h2>
          <p>
            Xaltech Fotos es una plataforma digital que conecta a fotógrafos deportivos con atletas participantes
            en eventos públicos, permitiendo la búsqueda, visualización y compra de fotografías tomadas durante
            dichos eventos, a través de un sistema automatizado de WhatsApp y un portal web. Los eventos
            cubiertos pueden realizarse tanto en México como en otros países.
          </p>
        </section>

        <section>
          <h2>3. Registro de fotógrafos</h2>
          <ul>
            <li>El fotógrafo es responsable de la veracidad de los datos proporcionados al registrarse.</li>
            <li>El fotógrafo garantiza tener los derechos sobre las fotografías que sube a la plataforma.</li>
            <li>El fotógrafo es responsable de contar con los permisos del organizador del evento para fotografiar.</li>
            <li>Si el fotógrafo cubre eventos fuera de México, es responsable de cumplir con las leyes locales de imagen, datos personales y fiscales del país correspondiente.</li>
            <li>Xaltech Fotos actúa como plataforma intermediaria y no se hace responsable del contenido subido por los fotógrafos.</li>
          </ul>
        </section>

        <section>
          <h2>4. Compra de fotografías</h2>
          <ul>
            <li>Los pagos son procesados de forma segura a través de <strong>Stripe</strong>.</li>
            <li>Una vez completado el pago, el comprador recibirá sus fotografías en alta resolución vía WhatsApp.</li>
            <li>Las fotografías adquiridas son para uso personal del comprador. No se permite su redistribución comercial.</li>
            <li>No se realizan reembolsos una vez entregadas las fotografías digitales, salvo error técnico comprobable.</li>
          </ul>
        </section>

        <section>
          <h2>5. Comisión de la plataforma</h2>
          <p>
            Por cada venta realizada a través de la plataforma, Xaltech Manufacturing Services SA de CV
            cobra una comisión por el servicio de intermediación tecnológica. Los detalles de la
            comisión son acordados directamente con cada fotógrafo registrado mediante contrato independiente.
          </p>
        </section>

        <section>
          <h2>6. Fotografías en eventos públicos y privados; consentimiento de imagen</h2>
          <p>
            Las fotografías de <strong>eventos deportivos de carácter público</strong> son tomadas en eventos de
            participación abierta. La fotografía en espacios y eventos públicos está permitida por la legislación
            mexicana. Al aceptar estos Términos y Condiciones, el usuario reconoce y autoriza expresamente que su
            imagen captada en dichos eventos públicos pueda ser almacenada, procesada y comercializada dentro de
            la plataforma Xaltech Fotos, únicamente en el contexto del evento deportivo en el que participó.
          </p>
          <p>
            En el caso de <strong>eventos privados</strong> (bodas, graduaciones, baby showers y similares), el
            fotógrafo registrado declara y garantiza contar con la autorización del organizador del evento, y en
            su caso de los asistentes, para fotografiar y comercializar dichas imágenes a través de la plataforma.
            Xaltech Fotos no participa en la obtención de esa autorización y no es responsable si el fotógrafo
            incumple esta garantía.
          </p>
          <p>
            Si entre las fotografías o selfies procesadas se encuentra la imagen de una persona menor de edad,
            quien utiliza el servicio en su nombre (ya sea enviando la selfie o adquiriendo sus fotografías)
            declara ser su padre, madre o tutor legal y actuar en su representación.
          </p>
          <p>
            Si el evento se realiza fuera de México, el fotógrafo registrado es responsable de cumplir
            además con la legislación local aplicable en materia de imagen y datos personales del país donde
            se realice el evento.
          </p>
          <p>
            Sin embargo, si algún participante considera que alguna imagen afecta su imagen o dignidad, puede
            solicitar su eliminación enviando un correo a <strong>xaltech1990@outlook.com</strong> con el número
            de foto y evento. Atenderemos la solicitud en un plazo máximo de 5 días hábiles.
          </p>
        </section>

        <section>
          <h2>7. Mensajes automatizados de WhatsApp</h2>
          <p>
            Al interactuar con el bot de WhatsApp de Xaltech Fotos, el usuario acepta recibir mensajes
            automatizados relacionados exclusivamente con el servicio: búsqueda de fotografías, proceso de
            compra, entrega de imágenes y soporte. Xaltech Fotos no enviará publicidad no solicitada.
            El usuario puede solicitar en cualquier momento dejar de recibir mensajes enviando la palabra
            <strong> STOP</strong> al número de WhatsApp de la plataforma.
          </p>
        </section>

        <section>
          <h2>8. Propiedad intelectual</h2>
          <p>
            Los fotógrafos conservan los derechos de autor sobre sus obras. Al subir fotografías a la
            plataforma, otorgan a Xaltech Fotos una licencia no exclusiva para mostrarlas, distribuirlas
            y venderlas dentro de la plataforma. El diseño, código y marca de Xaltech Fotos son propiedad
            de Xaltech Manufacturing Services SA de CV.
          </p>
        </section>

        <section>
          <h2>9. Limitación de responsabilidad</h2>
          <p>
            Xaltech Fotos no será responsable por daños indirectos, incidentales o consecuentes derivados
            del uso de la plataforma. La responsabilidad máxima de la empresa se limita al monto pagado
            por el usuario en la transacción correspondiente.
          </p>
        </section>

        <section>
          <h2>10. Modificaciones</h2>
          <p>
            Nos reservamos el derecho de modificar estos términos en cualquier momento. El uso continuado
            de la plataforma después de los cambios constituye la aceptación de los nuevos términos.
          </p>
        </section>

        <section>
          <h2>11. Ley aplicable y jurisdicción</h2>
          <p>
            Estos términos se rigen, con carácter general, por las leyes de los <strong>Estados Unidos
            Mexicanos</strong>, país donde se encuentra establecida Xaltech Manufacturing Services SA de CV.
            Para cualquier controversia, las partes se someten a la jurisdicción de los tribunales competentes
            de <strong>Guadalajara, Jalisco, México</strong>, renunciando a cualquier otro fuero que pudiera
            corresponderles por razón de su domicilio presente o futuro.
          </p>
          <p>
            Lo anterior no limita los derechos irrenunciables que la legislación local de protección al
            consumidor o de datos personales del país de residencia del usuario pudiera otorgarle, cuando
            dicha legislación sea de aplicación obligatoria conforme a su propia ley.
          </p>
        </section>

        <section>
          <h2>12. Contacto</h2>
          <p>
            Para cualquier asunto relacionado con estos términos:<br />
            📧 <strong>xaltech1990@outlook.com</strong>
          </p>
        </section>
      </div>
    </div>
  );
};

export default TerminosUso;
